// extracted by mini-css-extract-plugin
module.exports = {"A_1":"A_ZA_A_1__kPPbP"};